import React, {Component} from 'react';
import './TeamCard.css';

export default class TheTeam extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="team_card_container">
				<img className="team_card_picture" src={this.props.image} />
				<div className="team_card_content">
					<div className="team_card_name">{this.props.name}</div>
					<div className="team_card_title">{this.props.title}</div>

					<div className="team_card_description">{this.props.description}</div>
					{this.props.description2 && <div className="team_card_description"><span>{this.props.description2}</span></div>}
					{this.props.description3 && <div className="team_card_description"><span>{this.props.description3}</span></div>}
					{this.props.description4 && <div className="team_card_description"><span>{this.props.description4}</span></div>}
					<div className="team_card_description_positions_header">
						Positions Held:
					</div>
						<div>
							<ul className="team_card_description_positions_ul">
								{this.props.lastPosition && <li className="team_card_description_positions_li">
								{this.props.lastPosition}
								</li>}
								{this.props.lastPosition2 && <li className="team_card_description_positions_li">
								{this.props.lastPosition2}
								</li>}
								{this.props.lastPosition3 && <li className="team_card_description_positions_li">
								{this.props.lastPosition3}
								</li>}
								{this.props.lastPosition4 && <li className="team_card_description_positions_li">
								{this.props.lastPosition4}
								</li>}
								{this.props.lastPosition5 && <li className="team_card_description_positions_li">
								{this.props.lastPosition5}
								</li>}
								{this.props.lastPosition6 && <li className="team_card_description_positions_li">
								{this.props.lastPosition6}
								</li>}
								{this.props.lastPosition7 && <li className="team_card_description_positions_li">
								{this.props.lastPosition7}
								</li>}
							</ul>
						</div>
					</div>
			</div>
		)
	}
};
